import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const thetaPairGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Charm Pair',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX Charm Pair@tv-basicstudies-1",
        description: "SPX Charm Pair",
        shortDescription: "SPX Charm Pair",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },
        plots: [
          {
            id: "calls_theta",
            type: "line",
            title: "Calls Theta"
          },
          {
            id: "puts_theta",
            type: "line",
            title: "Puts Theta"
          },
          {
            id: "zero_line",
            type: "line",
            title: "Zero Line"
          }
        ],
        defaults: {
          styles: {
            calls_theta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 0,  // Line plot
              trackPrice: false,
              transparency: 0,
              visible: true,
              color: "#de88ff"  // Purple for calls
            },
            puts_theta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 0,  // Line plot
              trackPrice: false,
              transparency: 0,
              visible: true,
              color: "#9d7d00"  // Yellow for puts
            },
            zero_line: {
              linestyle: 0,
              linewidth: 1,
              color: "#ffffff",  // White zero line
              visible: true
            }
          },
          precision: 2,
          inputs: {}
        },
        styles: {
          calls_theta: { title: "Calls Theta" },
          puts_theta: { title: "Puts Theta" },
          zero_line: { title: "Zero Line" }
        },
        inputs: []
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            // Get latest data from store on each main() call
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
             const spxExposures = greekExposures.spx;


             if (!spxExposures?.length) {
              if (this._debugMode) {
                // console.log('[thetaPairGetter] No greek exposures data');
              }
              return [null, null, null];
            }

            const time = ctx.symbol.time;
            if (!time || isNaN(time)) {
              if (this._debugMode) {
                // console.log('[thetaPairGetter] Invalid symbol time:', time);
              }
              return [null, null, null];
            }

            const timeInSec = Math.floor(time / 1000);

            // Filter and sort theta exposures
            const thetaExposures = spxExposures
              .filter(exp => exp.greek_type === 'theta')
              .sort((a, b) => a.timestamp - b.timestamp);

            if (!thetaExposures.length) {
              return [null, null, null];
            }

            // Find the closest data point to the requested time
            let closestExp = thetaExposures[0];
            let minDiff = Math.abs(closestExp.timestamp - timeInSec);

            for (const exp of thetaExposures) {
              const diff = Math.abs(exp.timestamp - timeInSec);

              if (diff < minDiff) {
                minDiff = diff;
                closestExp = exp;
              }
            }

            const callsValue = parseFloat(closestExp.calls_total) || 0;
            const putsValue = parseFloat(closestExp.puts_total) || 0;

            // if (this._debugMode) {
            //   console.log(`[thetaPairGetter] Chart time: ${new Date(timeInSec * 1000).toLocaleString('en-US', {
            //     timeZone: 'America/New_York'
            //   })}, Using values - Calls: ${callsValue}, Puts: ${putsValue} from time: ${new Date(closestExp.timestamp).toLocaleString('en-US', {
            //     timeZone: 'America/New_York'
            //   })}`);
            // }

            return [callsValue, putsValue, 0];  // Return calls, puts, and zero line values
          } catch (err) {
            // console.error('[thetaPairGetter] Error in main:', err);
            return [null, null, null];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      }
    }
  ]);
};